<template>
  <Dashboard />
</template>

<script>
// Components
import Dashboard from "@/components/Dashboard";
export default {
  name: "HomeView",

  components: {
    Dashboard,
  },
};
</script>

<style scoped>
</style>